import requestFunctions from "../../functions/requestFunctions";


export const state = {

}

export const getters = {

}

export const mutations = {

}

export const actions = {

  async FETCH_MOVINGS_PRODUCTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MOVINGS_PRODUCTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/products/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MOVINGS_PRODUCTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/products/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}